import React from "react";
import { Button } from "primereact/button";
import localeText from "../../../../../../locale";
import { formatPrice } from "../../../../../../utilities/formatPrice";

const PlatformExcCard = ({ balance, isLoading, disabled, onWithdraw, onStatement }) => (
  <div
    className="card border-round-lg flex flex-column justify-content-between p-4 h-full"
    style={{
      minHeight: "220px",
      border: "1px solid var(--theme-border, #EBEBEB)",
    }}
  >
    <div className="flex align-items-top justify-content-between mb-4">
      <img
        src={`${process.env.PUBLIC_URL}/assets/layout/images/icone_extracoin_site.webp`}
        alt="Extracoin"
        width="52"
        height="52"
      />
      <div>
        <span
          className="px-3 py-1 border-round-md text-xs font-medium uppercase"
          style={{
            backgroundColor: "var(--theme-border, #EBEBEB)",
            color: "var(--theme-text, #262626)",
          }}
        >
          {localeText("extrapayFlowTitle")}
        </span>
      </div>
    </div>
    <div className="text-xs font-bold mb-2" style={{ color: "var(--theme-text-muted, #7A869A)" }}>
      {localeText("extrapayFlowPlatformBalance")}
    </div>
    <div className="mb-2">
      <span className="text-2xl font-bold" style={{ color: "var(--theme-text, #344563)" }}>
        {isLoading ? "—" : formatPrice(balance || 0)}{" "}
        <span className="text-sm font-medium">EXC</span>
      </span>
    </div>
    <div className="text-xs" style={{ color: "var(--theme-text-muted, #7A869A)" }}>
      {localeText("extrapayFlowAvailableExternal")}
    </div>
    <hr className="my-4" style={{ borderColor: "var(--theme-border, #EBEBEB)" }} />
    <div className="flex gap-2 flex-wrap">
      <Button
        label={localeText("extrapayFlowRequestWithdraw")}
        className="p-button-text text-sm flex-1 border-round-md"
        style={{
          backgroundColor: "color-mix(in srgb, var(--theme-secondary) 15%, transparent)",
          color: "var(--theme-secondary)",
        }}
        onClick={onWithdraw}
        disabled={disabled}
      />
      <Button
        label={localeText("statement")}
        className="p-button-text text-sm flex-1 border-round-md"
        style={{
          border: "1px solid var(--theme-border, #EBEBEB)",
          color: "var(--theme-text-muted, #5C5C5C)",
        }}
        onClick={onStatement}
      />
    </div>
  </div>
);

export default React.memo(PlatformExcCard);
